'use es6';

import { List } from 'immutable';
import { getQueryParamNames } from '../utils/paramHelpers';
export const HeaderQueryParams = {
  HEADER_DETAILS_SIDEBAR_OPEN: {
    param: 'headerDetailsSidebarOpen',
    stateName: 'headerDetailsSidebarOpen'
  },
  LANGUAGE_VARIATION: {
    param: 'languageVariation',
    stateName: 'languageVariation'
  },
  MAB_END_TEST_MODAL_OPEN: {
    param: 'mabEndTestModalOpen',
    stateName: 'mabEndTestModalOpen'
  }
};
export const HeaderQueryParamNames = getQueryParamNames(HeaderQueryParams);
export const queryParamToStateName = param => {
  const paramData = HeaderQueryParams[param];

  if (!paramData) {
    return '';
  }

  return paramData.stateName || '';
};
const VALID_BOOLEAN_VALUES = List.of('true', 'false');
export const DEFAULT_HEADER_QUERY_PARAM_VALUES = {
  [HeaderQueryParamNames.HEADER_DETAILS_SIDEBAR_OPEN]: false,
  [HeaderQueryParamNames.MAB_END_TEST_MODAL_OPEN]: false
};
export const VALID_HEADER_QUERY_PARAM_VALUES = {
  [HeaderQueryParamNames.HEADER_DETAILS_SIDEBAR_OPEN]: val => VALID_BOOLEAN_VALUES.includes(val),
  [HeaderQueryParamNames.MAB_END_TEST_MODAL_OPEN]: val => VALID_BOOLEAN_VALUES.includes(val)
};